/**
 * Standard product GraphQL query
 */
export const productQuery = `edges {
  node {
      id
      title
      handle
      tags
      productType
      images(first: 2) {
          edges {
              node {
                originalSrc
              }
          }
      }
      priceRange {
          maxVariantPrice {
              amount
          }
          minVariantPrice {
              amount
          }
      }
      variants(first: 1) {
          edges {
              node {
                  id
                  compareAtPriceV2 {
                      amount
                  }                                
              }
          }
      }
  }
  cursor
}
pageInfo {
  hasNextPage
}`;

/**
 * The products loaded from graphQL need to be edited to
 * - name variables to match liquid versions
 * - set URL correctly
 * - fix IDs with atob()
 * - set pricing correctly
 */
export function transformProduct(productNode, collectionHandle=null) {
    const availableVariant = productNode.variants.edges
        .find(edge => edge.node.availableForSale)
    
    const availableVariantId = availableVariant ? parseInt(atob(availableVariant.node.id).replace("gid://shopify/ProductVariant/", "")) : ''

    // for variant object
    const getVariantID = (variant) =>  parseInt(atob(variant).replace("gid://shopify/ProductVariant/", ""));
    const getOptionName = (option) => option.includes('/') ? option.split(' / ')[1] : 'One Size';
    const filterVariantObject = variant => ({ 'id': getVariantID(variant.node.id), 'title': getOptionName(variant.node.title), 'available': variant.node.availableForSale});

    return {
        type: "product",
        available: productNode.availableForSale,
        handle: productNode.handle,
        url: !!collectionHandle 
            ? `/collections/${collectionHandle}/products/${productNode.handle}${availableVariant ? `?variant=${availableVariantId}` : ''}`
            : `/products/${productNode.handle}${availableVariant ? `?variant=${availableVariantId}` : ''}`,
        id: parseInt(atob(productNode.id).replace("gid://shopify/Product/", "")),
        tags: productNode.tags.map(tag => tag.toLowerCase()),
        productType: productNode.productType,
        title: productNode.title,
        options: productNode.variants.edges.map(variant => variant.node.title),
        variants: productNode.variants.edges.map(filterVariantObject),

        price: productNode.presentmentPriceRanges.edges[0]?.node.minVariantPrice.amount * 100,

        compare_at_price: productNode.variants.edges[0]?.node.presentmentPrices.edges[0]?.node.compareAtPrice ? 
            productNode.variants.edges[0]?.node.presentmentPrices.edges[0]?.node.compareAtPrice.amount * 100 
            : null,

        images: productNode.images.edges.map(image => image.node.originalSrc)
    }
}

export const multipleProductQuery = ({currency, ids}) => {
    return `{
        nodes(ids: [${ids}]) {
            id
            ... on Product {
                    id
                    title
                    handle
                    availableForSale
                    tags
                    productType
                    images(first: 2) {
                        edges {
                            node {
                                originalSrc
                            }
                        }
                    }
                    presentmentPriceRanges(presentmentCurrencies: ${currency}, first: 1) {
                        edges {
                            node {
                                minVariantPrice {
                                    amount
                                }
                            }
                        }
                    }
                    variants(first: 15) {
                        edges {
                            node {
                                id
                                title
                                availableForSale
                                presentmentPrices(presentmentCurrencies: ${currency}, first: 1) {
                                    edges {
                                        node {
                                            compareAtPrice {
                                                amount
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `
}